import React, { useEffect, useState } from 'react';

/**
 * Componente para mostrar notificações de sessão expirada
 * Deve ser usado no App.js ou layout principal
 */
function SessionExpiredNotification() {
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    // Verificar se há mensagem de erro de sessão no localStorage
    const checkSessionError = () => {
      const authError = localStorage.getItem('authErrorMessage');
      if (authError) {
        setMessage(authError);
        setShow(true);
        localStorage.removeItem('authErrorMessage');
        
        // Auto-esconder após 5 segundos
        setTimeout(() => {
          setShow(false);
        }, 5000);
      }
    };

    checkSessionError();
    
    // Verificar a cada segundo (para casos onde usuário volta para login)
    const interval = setInterval(checkSessionError, 1000);
    return () => clearInterval(interval);
  }, []);

  if (!show) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: '20px',
        right: '20px',
        background: '#fef3c7',
        border: '2px solid #f59e0b',
        borderRadius: '12px',
        padding: '16px 20px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        zIndex: 10000,
        maxWidth: '400px',
        animation: 'slideInRight 0.3s ease'
      }}
    >
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
        <div style={{ fontSize: '24px', flexShrink: 0 }}>⚠️</div>
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: 700, color: '#92400e', marginBottom: '4px' }}>
            Sessão Expirada
          </div>
          <div style={{ fontSize: '0.85rem', color: '#78350f' }}>
            {message || 'Sua sessão expirou. Faça login novamente.'}
          </div>
        </div>
        <button
          onClick={() => setShow(false)}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontSize: '20px',
            color: '#92400e',
            padding: '0',
            lineHeight: 1
          }}
        >
          ×
        </button>
      </div>
    </div>
  );
}

export default SessionExpiredNotification;
